export const fadeInAnimation = {
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(20px)' },
    to: { opacity: 1, transform: 'translateY(0)' }
  },
  animation: 'fadeIn 0.6s ease-out forwards',
  opacity: 0
}

export const paragraphStyle = {
  my: 4,
  fontSize: { xs: '1rem', md: '1.1rem' },
  lineHeight: 1.8,
  // maxWidth: '800px',
  mx: 'auto',
  ...fadeInAnimation
}